import { Finder, IFinder } from '../finder/IFinder';
import { IWykrojnikRow } from "../wykrojniki/IWykrojnikRow";

export interface IKosztyTransportu {
	naklad: number;
	mkw: number;
	waga: number
	koszt: number
}

export interface ITransport {
	
	tree_id: string|undefined

	data: Date
	kod_pocztowy_finder:IFinder;

	naklady: number[]
	wykrojnik:IWykrojnikRow|undefined
	straty_surowca_faktor:number;

	koszty_transportu: IKosztyTransportu[]

	_id:any
	version:number
	created_date: Date;

}


export class Transport implements ITransport {

    tree_id: string|undefined

	data: Date = new Date()
	kod_pocztowy_finder:IFinder=new Finder();
	naklady: number[]=[]
	wykrojnik:IWykrojnikRow|undefined
	straty_surowca_faktor:number=0.1;

	koszty_transportu: IKosztyTransportu[]=[]

	_id:any
	version:number=0
	created_date: Date=new Date();

	public static get_koszt_transportu_dla_nakladu(transport:ITransport|undefined, naklad:number ):number {
		if (!transport) return 0;
		const koszty_transportu: IKosztyTransportu[]=transport.koszty_transportu;
		let koszt=0;
	
		for (let i=0;i<koszty_transportu.length;i++) {
			const k=koszty_transportu[i]
			if (k.naklad <= naklad) koszt=k.koszt;
			else return koszt;		
		}
		return koszt;
	}
	
}